import { Alert } from 'react-bootstrap';

interface IProps {
    message: string
}

const NoData = (props: IProps) => {
    return (
        <div style={{ padding: '1%' }}>
            <Alert bsStyle='info' style={{ textAlign: 'center', padding: 7.5 }}>{props.message}</Alert>
        </div>
    );
}

export default NoData;